var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 10,
    transform: "rotate(90 35 0.5)",
    stroke: "#CED3DE",
    strokeMiterlimit: 0,
    strokeLinejoin: "bevel"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9809 17.5C13.9809 17.2699 14.0773 17.0398 14.2699 16.8644L20.3333 11.3439C20.719 10.9928 21.3443 10.9928 21.7299 11.3439C22.1154 11.695 22.1154 12.2642 21.7299 12.6154L16.3647 17.5L21.7297 22.3845C22.1152 22.7357 22.1152 23.3049 21.7297 23.6559C21.3441 24.0072 20.7188 24.0072 20.3331 23.6559L14.2697 18.1356C14.0771 17.96 13.9809 17.73 13.9809 17.5V17.5Z",
    fill: "#222B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevCalendar);
export default __webpack_public_path__ + "static/media/prev-calendar.e099713537581f99213820583cd9d7c1.svg";
export { ForwardRef as ReactComponent };